<template>
  <article class="card-link">
    <a href="/">
      <div class="card-link__bg" v-if="hasImage()">
        <img :src="getImage" alt="Alt description for the image">
      </div>
      <div class="card-link__wrapper">
        <h3 class="card-link__header">
          <TextHeading>
            <span class="card-link__text">{{ category }}</span>
            {{ title }}
            <span v-if="role" class="card-link__role">{{ role }}</span>
          </TextHeading>
        </h3>
        <div class="card-link__more">
          <BaseIconText iconAfter="arrow_forward" size="16">{{ link }}</BaseIconText>
        </div>
      </div>
    </a>
  </article>
</template>

<script>
import BaseIconText from '../elements/BaseIconText.vue'
import TextHeading from '../elements/TextHeading.vue'
export default {
  name: 'CardLink',
  components: { TextHeading, BaseIconText },
  props: {
    image: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Article title goes here'
    },
    role: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: 'More information'
    },
    category: {
      type: String,
      default: 'Category'
    }
  },
  methods: {
    hasImage() {
      return this.image.length
    }
  },
  computed: {
    getImage() {
      if (this.hasImage()) {
        return require('@/assets/images/' + this.image)
      }
      return ''
    }
  }
}
</script>

<style lang="postcss">
.card-link {
  @apply cursor-pointer bg-primary-lightest relative h-full flex-1 transition-fast;
}
.card-link a {
  @apply no-underline text-body;
}
.card-link__bg {
  @apply inset-0 absolute h-full opacity-0 overflow-hidden transition-fast;
}
.card-link__bg img {
  @apply inset-0 absolute w-full h-full;
  object-fit: cover;
}
.card-link__bg:after {
  @apply inset-0 block absolute bg-primary opacity-90;
  content: '';
}

.card-link:hover,
.card-link:hover a {
  @apply text-white bg-primary;
}
.card-link:hover .card-link__bg {
  @apply opacity-100;
}
.card-link:hover .card-link__bg img {
}
.card-link:hover .card-link__more {
  @apply border-white;
}

.card-link__wrapper {
  @apply px-8 pt-20 pb-16 flex flex-col h-full relative;
}
.card-link__header {
  @apply flex-1;
  flex-basis: auto;
}
.card-link__text {
  @apply mb-2 block text-sm font-normal tracking-wide;
}
.card-link__role {
  @apply block;
}
.card-link__more {
  @apply border-body border-t mt-4 py-6 transition-border;
}
</style>
